import moment from 'moment';
import TagsInput from '@/components/Inputs/TagsInput'
import HttpFactory from '@/mixins/http.factory';
import { Select, Option } from 'element-ui'
import HtmlEditor from '@/components/Inputs/HtmlEditor'

//client data
import projectData from './projects';
import projectDetailsData from './project-details';
export default {
	mixins:[HttpFactory],
	data () {
		return {
			htmlMessage:null,
			data:null,
			devOpsProjects:[],
      devOpsProjectData:{
          workItemTypes:[],
          nodesList:[],
          fieldsList:[],
          usersList:[],
          customFields:[]
      },
			showTags:false,
      editor_reproSteps_Obj:null,
      editor_description_Obj:null,
			createItemData: { attachments: [], files: [], fields: {} },
      showFields: false,
      zdOrganizations: [],
      drpPriorityOptions:[]
		}
	},
	created(){
		this.init();
	},
	methods:{
		init(){
			let _self=this;
			modalClient = ZAFClient.init();
			parentClient=null;
			//var count=0;
			modalClient.on('send_data_to_modal', (data) => {
				if (data.ticket.id == _self.$route.params.zdTicketId) {
					parentClient = modalClient.instance(data.parentClientGuid)
					_self.zendeskInfo = data;
					_self.workItemFields();
				}
				// _self.zendeskInfo=data;
				// count++;
				// if(count==1){
				// 	_self.workItemFields();
				// }
			});
		},
		initDropzone(data){
			const _self=this;
			if(!data || !data.userInfo || !data.userInfo.uploadFiles)return;
			_self.fn().initDropzone('div.dropzone',data.credentials,'devops',function(error,response){
				_self.fn().clearMessage();
				if(error){
					_self.userMsg={show:true,type:'danger',list:[response?response:error]}
					return;
				}
				_self.createItemData.files=_self.createItemData.files.concat(response);
			});
		},
		removeFile(file){
			const _self=this;
			_self.createItemData.files=_self.createItemData.files.filter(d=>d.id!=file.id);
		},
		initJSTree(devOpsProjectData){
			let _self=this;


			_self.fn().createJSTree('area_jstree',function(selectedObj){
				let selPath=selectedObj.path.replace('\\Area',''); //`${_self.createItemData.project.name}\\${selectedObj.text}`;
				selPath=selPath.startsWith('\\')?selPath.substr(1,selPath.length-1):selPath;
				_self.createItemData.fields['System.AreaPath']=selPath;
			});

			_self.fn().createJSTree('iterations_jstree',function(selectedObj){
				let selPath=selectedObj.path.replace('\\Iteration','');//`${_self.createItemData.project.name}\\${selectedObj.text}`;
				selPath=selPath.startsWith('\\')?selPath.substr(1,selPath.length-1):selPath;
				_self.createItemData.fields['System.IterationPath']=selPath;
			});
			_self.fn().updateJSTreeData('area_jstree',devOpsProjectData.nodesList.value.filter(d=>d.structureType=='area'));
			_self.fn().updateJSTreeData('iterations_jstree',devOpsProjectData.nodesList.value.filter(d=>d.structureType=='iteration'));

			_self.handleDefAreaIteration(devOpsProjectData)

		},
		handleDefAreaIteration(devOpsProjectData){
			const _self=this;

			let defArea='520';
			let defIteration='508';// 571

			//filter default Zendesk area
			let zdArea =devOpsProjectData.nodesList.value.find(d=>d.structureType=='area').children.find(d1=>d1.text=='Zendesk');
			defArea=zdArea?zdArea.id.toString():'';


			let zdIteration =devOpsProjectData.nodesList.value.find(d=>d.structureType=='iteration');//.children[0];
			defIteration=zdIteration?zdIteration.id.toString():'';

			setTimeout(function(){
				//_self.fn().setJSTreeDefValue('area_jstree',defArea)
				_self.fn().setJSTreeDefValue('iterations_jstree',defIteration)
			},1000)
		},
		async initCreateItemData(data,project){
			let _self=this;
			_self.createItemData.fields={
				'System.Title':'' // no need to auto fill
			};

			let comments=_self.zendeskInfo.ticket.comments;
			if(comments){
				let description_html=comments && comments.length>0?comments[comments.length-1].value:_self.zendeskInfo.ticket.description;
				_self.createItemData.fields['System.Description']=description_html;
			}
			_self.createItemData.hdTicketId=data.hdTicketId?data.hdTicketId:data.ticket.id;
			_self.createItemData.fields['System.TeamProject']=project?project.name:'';
			//_self.createItemData.fields['System.Title']='';//data.ticket.subject;
			//console.log('zendesk info',data);
			_self.createItemData.fields['Microsoft.VSTS.Common.Priority']=data.ticket.priority>0?data.ticket.priority:_self.handlePrioritySet(data.ticket.priority);
			_self.createItemData.fields['Custom.drpPriority']=data.ticket.priority?_self.handleCustPrioritySet(data.ticket.priority):data.ticket.priority;
			//console.log('priority',data.ticket.priority,_self.createItemData.fields['Custom.drpPriority']);
			_self.createItemData.fields['System.AssignedTo']=_self.getAssigneeEmailByProject();
			_self.createItemData.fields['System.WorkItemType']='User Story';//default user story
			_self.createItemData.fields['Microsoft.VSTS.Common.Severity']='';
			_self.createItemData.fields['System.Tags']='';
			_self.createItemData.fields['System.TagsArr'] =_self.createItemData.fields['System.Tags']?_self.createItemData.fields['System.Tags'].split(';'):[];

			//cf
      _self.createItemData.fields['sparkplug-process.ClientName'] = [];
      _self.createItemData.fields['Custom.Customer']=[];
      //_self.createItemData.fields['Custom.drpPriority']='';

			_self.createItemData.fields['System.CreatedBy']=_self.zendeskInfo.user.email;


			_self.showTags=true;

			await _self.handleClientNameMap();

    },
    getAssigneeEmailByProject() {
      let _self = this;
      let assigneeEmail = null;
      switch (_self.createItemData.projectId) {
        case 'a38889cb-1816-4ac4-8941-61cf13c22890'://CRAFT
          assigneeEmail = 'dimelza.remedios@enerex.com';
          break;
        case 'a2aabdcc-5a66-41dc-aa44-e983da453805'://BrokerHub
          assigneeEmail = 'pia.gonzalez@enerex.com';
          break;
        case '078a0b2b-8f65-4eaf-ae69-6c6601e2c7d3'://DataHub
          assigneeEmail = 'ane.aguilar@enerex.com';
          break;
        case 'a5ca636d-278a-4cf0-89e9-032787376a50'://Enerex Common
          assigneeEmail = 'ane.aguilar@enerex.com';
          break;
        case '2cbef76a-3088-4187-b486-22793a5ebcd7'://Exchange Live
          assigneeEmail = 'ane.aguilar@enerex.com';
          break;
        case 'e63dc913-3d19-45db-a5a6-8f1017522a00'://Generator
          assigneeEmail = 'ane.aguilar@enerex.com';
          break;
        case 'ad28e9b5-28de-490a-ba1d-1d6acbcbd711'://MarketHub
          assigneeEmail = 'ane.aguilar@enerex.com';
          break;
        case '85723131-d994-438c-8533-9ab85d694e0e'://SupplierHub
          assigneeEmail = 'inalbis.rodriguez@enerex.com';
          break;
        default:
          break;
      }
      return assigneeEmail;
    },
    async fetchClientNames_ZDOrganizations() {
      const _self = this;
      let organizations = await _self.fn().getAllOrganizations(parentClient);
      return organizations.map(d=>d.name);
    },
		async handleClientNameMap(){
			const _self = this;
			//_self.showFields = false;
			//let cfId='360018283698';//devops
			//let cfId='360047799113';//powermatrix
			//let request = ['ticket.customField:custom_field_' + 360018283698];//sandbox
			let request=['ticket.customField:custom_field_'+360047799113];//live
    		let response=await parentClient.get(request);
			let clientNameVal = response[request[0]];//client name

			//client field
			if (clientNameVal) {
				let field = _self.devOpsProjectData.customFields.find(d => d.referenceName == 'sparkplug-process.ClientName');
				if (field) {
					let isValExist = field.allowedValues.find(d => d == clientNameVal);
					if (!isValExist) {

						field.allowedValues.push(clientNameVal);
					}
				}
				_self.createItemData.fields['sparkplug-process.ClientName'] = [clientNameVal];


        //for the new field Customer
				field = _self.devOpsProjectData.customFields.find(d => d.referenceName == 'Custom.Customer');
				if (field) {
					let isValExist = field.allowedValues.find(d => d == clientNameVal);
					if (!isValExist) {

						field.allowedValues.push(clientNameVal);
					}
				}
				_self.createItemData.fields['Custom.Customer'] = [clientNameVal];
			}

		},
		handleCustPrioritySet(priority){
			let strPriority='';
			switch(priority){
				case 'low':
					strPriority='5-Low';
					break;
				case 'normal':
					strPriority='4-Medium';
					break;
				case 'high':
					strPriority='3-High';
					break;
				case 'urgent':
					strPriority='2-Critical';
					break;
			}
			return strPriority;
		},
		handlePrioritySet(priority){
			let intPriority='';
			switch(priority){
				case 'low':
					intPriority=1;
					break;
				case 'normal':
					intPriority=2;
					break;
				case 'high':
					intPriority=3;
					break;
				case 'urgent':
					intPriority=4;
					break;
			}
			return intPriority;
		},
		onDateChanged(date,el) {
			let _self = this;
			let referenceName=el.target.getAttribute('referenceName');
			_self.createItemData.fields[referenceName]=date?_self.apiDateValue(date):null;
		},
		htmlEditorChange(data){
			const _self=this;
			_self.createItemData.fields[data.referenceName]=data.htmlContent?data.htmlContent:null;
		},
		formatDateValue(date){
			if(!date) return null;
			return moment(date).format('MM/DD/YYYY');
		},
		apiDateValue(dateObj){
			let _self=this;
			let date=_self.formatDateValue(dateObj);
			//return date;
			if(!date) return null;

			var currentDate = new Date();
			var newDate= (new Date(`${date} `+currentDate.toLocaleTimeString()));
			newDate.setMinutes(newDate.getMinutes()+(currentDate.getTimezoneOffset()*-1));
			return newDate.toISOString();
			//return newDate;
		},
		async handleDefaultProjectNameMap(){
			const _self = this;
			let defaultProjectName = 'Sparkplug R2';
			//let request = ['ticket.customField:custom_field_' + 360028657817];//sandbox
			let request=['ticket.customField:custom_field_'+23751547];//live
    		let response=await parentClient.get(request);
			let productNameVal = response[request[0]];//product name

			if (productNameVal == 'propeller' && _self.createItemData.projectId!='85723131-d994-438c-8533-9ab85d694e0e') {
				_self.createItemData.projectId = '85723131-d994-438c-8533-9ab85d694e0e';
				defaultProjectName = 'Propeller R2';
			}

			if (productNameVal == 'craft' && _self.createItemData.projectId!='a38889cb-1816-4ac4-8941-61cf13c22890') {
				_self.createItemData.projectId = 'a38889cb-1816-4ac4-8941-61cf13c22890';
				defaultProjectName = 'CRAFT';
			}

			return defaultProjectName;

		},
		async workItemFields(){
      let _self = this;

      _self.zdOrganizations=await _self.fetchClientNames_ZDOrganizations();
			//let defaultProjectName=await _self.handleDefaultProjectNameMap();
			let defaultProjectName = 'Sparkplug R2';
			_self.devOpsProjectsFn(function(projectsResp){
				let devOpsProjects=projectsResp.data.Data.value;
				_self.htmlMessage=projectsResp.data.htmlMessage;
				if(devOpsProjects.length>0){
					let defaultP = devOpsProjects.find(d => d.name == defaultProjectName)
					_self.createItemData.projectId=defaultP?defaultP.id:devOpsProjects[0].id;
					_self.getDevOpsProjectData(function(devOpsProjectData){
						_self.devOpsProjects=devOpsProjects;
						_self.fn().showLoader(false);
						setTimeout(function(){_self.initDropzone(_self.zendeskInfo);},500);
						setTimeout(function(){
							_self.initJSTree(devOpsProjectData);
							// _self.fn().createHtmlEditor('editor_reproSteps','editor_reproSteps',null,function(editorObj,error){
							// 	_self.editor_reproSteps_Obj=editorObj?editorObj:null;
							// });
							let comments=_self.zendeskInfo.ticket.comments;
							if(comments){
								//let description_html=comments && comments.length>0?comments[comments.length-1].value:_self.zendeskInfo.ticket.description;
								//_self.createItemData.fields['System.Description']=description_html;
								// _self.fn().createHtmlEditor('editor_description','editor_description',description_html,function(editorObj,error){
								// 	_self.editor_description_Obj=editorObj?editorObj:null;
								// });
							}
						},1000);
					})
				}

			});
		},
		async getDevOpsProjectData(cb){
			let _self = this;
			_self.showFields=false;
			let projectId=_self.createItemData.projectId;
			await _self.initCreateItemData(_self.zendeskInfo,projectId);
			_self.devOpsProjectDataFn(projectId,function(data){
				let devOpsProjectData=data.data.Data;

        let drpPriorityField = devOpsProjectData.fieldsList.value.find(d => d.referenceName =='Custom.drpPriority');
        _self.drpPriorityOptions = drpPriorityField ? drpPriorityField.allowedValues : [];
				//filters
				devOpsProjectData.workItemTypes.value=devOpsProjectData.workItemTypes.value.filter(d=>d.name=='User Story' || d.name=='Issue' || d.name=='Support')
        devOpsProjectData.fieldsList.value = devOpsProjectData.fieldsList.value.filter(d => d.referenceName == 'sparkplug-process.ClientName123'
          || d.referenceName == 'Custom.Customer')

        let clientField = devOpsProjectData.fieldsList.value.find(d => d.referenceName == 'sparkplug-process.ClientName')
				if (clientField) {
					clientField.isPicklist = true;
					clientField.isRequired = true;
          //clientField.allowedValues = ["Internal", "3 Point Energy", "4Ward Energy Solutions", "Able Power Management", "Access Energy, LLC", "Achieve Energy Solutions, LLC", "ADL High Voltage", "Advanced Energy Resources", "Advantage Energy Partners", "Aegean Energy LLC", "AEP Energy", "Affordable Gas & Electric", "Allegiant Energy LLC", "Altekruse", "Amax Energy", "Amerex", "America's Choice Electricity", "American National Gas & Electric Company, LLC", "AMERIgreen", "Amerigy Energy LLC", "APG&E", "Aspen Energy", "Axiom Retail Energy", "Balanced Rock", "BCG Energy", "Best Decision Power", "Blue Sky Power", "Bold Coast Energy", "BPG Consultants", "Breaker Box", "Bridge Energy Services", "Bridge Power", "Bright  Energy Partners", "Bright Energy Partners", "Brilliant Source Energy", "Broker Connects (EPS)", "Buckeye Utility Solutions", "Business Energy Group", "Caprock Consulting Inc.", "CBRE", "Charity + Power", "Choice Energy Services Retail, LP", "Compare The Utility Market", "Compete Energy", "Concord Energy", "Connect Energy Resources", "CORE Marketplace", "CRAFT Support Helpdesk", "CSD Energy Advisors", "CTTU LTD", "Culver Energy Consulting", "Custom Energy Solutions", "David Energy", "Dawn Energy Consulting", "Deep Ellum Power and Gas", "Deregulated Solutions", "Diversegy", "E-Volve Energy", "East Coast Energy Management", "Ebullience", "Eco Logic Partners", "EcoEnergy", "EDF", "EDF Energy", "Efficient Energy", "EGS Advanced Energy Solutions", "Electrasource", "Electric Advisors, Inc.", "Elite Energy Solutions", "Elixir Power Solutions", "EnerConnex", "Enerex", "Enerex Help Center", "Energy 4 U Inc.", "Energy Auction Exchange", "Energy Connection", "Energy Edge Consulting", "Energy Guru LLC", "Energy Harbor", "Energy Initiatives", "Energy Objective", "Energy Professionals", "Energy Source Consulting, LLC", "EnergyCX", "EnergyServ Solutions", "EnerPower", "Engie", "Even Load Energy", "Everlast Energy (No Plateau LLC)", "Evolution Energy Partners", "Evolution Promotions Inc.", "Evolving Energy", "EZ Choice Energy", "EZ Energy", "F and D Partners", "FPB Energy, LLC", "Freepoint", "Freepoint Solutions", "Frontline", "FS Energy LLC", "Global Energy Management", "Globele Energy", "Goldstar Energy", "Green Crown Energy", "Greenline Energy", "GSE Consulting, LP", "Guardian Electric and Gas", "Gulf Plains Energy", "Honest Gorilla", "Infinity Power Partners, LLC", "INSO Energy", "IntelliGen Resources", "J & H Energy", "Joule Assets", "Just Energy", "Kairos Energy Ventures", "KEYTEX Energy Solutions", "Kizmet Energy", "LakePoint Energy", "Latern Power", "Lexus Power", "Live Energy", "Lower Electric", "Lower Watt", "Lykins Energy Advisors", "M&R Energy Resources", "M3 Energy", "Marathon Energy", "MDM-Energy Solutions", "Mega Energy", "Meretz Energy LLC", "Metronome Energy", "MHSC Energy Management, LLC", "Mighty EM", "Momentum Energy Services", "MP2 Energy", "Nania Energy", "National Energy Brokers Inc.", "National Utility Refund LLC", "National1energy", "Nationwide New Energy", "NAUP", "Nelson Premier Energy", "New America Power", "New Era Power LLC", "New Rate Energy", "Nicor Gas", "Noble HIll Brokerage", "Novo Energy", "Ohio Industrial Energy", "Olivia Corp", "Onyx Power & Gas Consulting", "Op2mize Energy", "Orzel Energy", "P2P Energy Solutions, Inc.", "Palmer", "Pariveda", "Park Place Power", "Patent Energy", "Pathway Energy", "Peritus Energy and Water", "Power Brokers", "Power Connection", "Power Experts LLC", "Power Logix", "Powernmore", "Powerserv Tech", "Pratt Power Partners", "Precedo Capital", "Premier Energy", "Progressive Energy Consultants", "ProSource Power", "ProStar Energy Services", "Prudential Energy", "QFB Energy", "Quantum Gas and Power Services, LTD", "Quantum Spectrum Energy", "Rave Energy", "RealPage, Inc.", "Reflective Energy Solution", "Retail Power Services", "River Oaks Energy", "Sable Power and Gas", "Saigon Power (formerly Q2X)", "Savant Energy", "Schneider Electric", "Seven Utility Management Consultants", "Simplified Power", "Single Source Energy Solutions", "Sparkplug", "Spike Energy, Inc.", "Statistical Energy", "Stellar Energy Solutions", "Strategic Insights", "SU4Energy", "Summer Energy", "SunRise Energy, LLC", "Sustainable Westchester", "Switch Energy Office", "Switchenergyny", "Symbio Energy Partners", "Taurus Utility Consultants", "TES Energy Services", "Test", "Texzon Utilities", "The Energy Company", "The Energy Depot", "The Linc Group", "The Power Company", "Titan Energy New England", "Tobelmann Energy Brokers, Inc.", "Tomorrows Utilities", "TPL Energy", "Transparent Energy", "TransPower Energy Group", "Triple S Energy", "TXU", "U-Go Christ", "UCE Partners", "UControl Energy", "UES- United Energy Services", "Ultimate Energy Advisors, LLC", "Unified Energy Services, LLC", "United Commercial Energy Partners", "United Power Consultants", "USA Group Energy", "USEC LLC (US Energy Consultants)", "Utility Connect", "Utility Savings Group", "Utiliz", "Vantage ETC", "Varo Technologies", "Vault Energy Solutions", "Verity Power Group", "Voltstreet", "Watts Marketing Services", "World Kinect Energy Services", "World Kinect Energy Services [UK]", "Worthington Energy Consultants", "YG Energy Consulting", "Your Choice Energy LLC", "Zingo Energy"]
          clientField.allowedValues = _self.zdOrganizations;
        }

        let customerField = devOpsProjectData.fieldsList.value.find(d =>d.referenceName == 'Custom.Customer')
				if (customerField) {
					customerField.isPicklist = true;
					customerField.isRequired = true;
          //customerField.allowedValues = ["Internal", "3 Point Energy", "4Ward Energy Solutions", "Able Power Management", "Access Energy, LLC", "Achieve Energy Solutions, LLC", "ADL High Voltage", "Advanced Energy Resources", "Advantage Energy Partners", "Aegean Energy LLC", "AEP Energy", "Affordable Gas & Electric", "Allegiant Energy LLC", "Altekruse", "Amax Energy", "Amerex", "America's Choice Electricity", "American National Gas & Electric Company, LLC", "AMERIgreen", "Amerigy Energy LLC", "APG&E", "Aspen Energy", "Axiom Retail Energy", "Balanced Rock", "BCG Energy", "Best Decision Power", "Blue Sky Power", "Bold Coast Energy", "BPG Consultants", "Breaker Box", "Bridge Energy Services", "Bridge Power", "Bright  Energy Partners", "Bright Energy Partners", "Brilliant Source Energy", "Broker Connects (EPS)", "Buckeye Utility Solutions", "Business Energy Group", "Caprock Consulting Inc.", "CBRE", "Charity + Power", "Choice Energy Services Retail, LP", "Compare The Utility Market", "Compete Energy", "Concord Energy", "Connect Energy Resources", "CORE Marketplace", "CRAFT Support Helpdesk", "CSD Energy Advisors", "CTTU LTD", "Culver Energy Consulting", "Custom Energy Solutions", "David Energy", "Dawn Energy Consulting", "Deep Ellum Power and Gas", "Deregulated Solutions", "Diversegy", "E-Volve Energy", "East Coast Energy Management", "Ebullience", "Eco Logic Partners", "EcoEnergy", "EDF", "EDF Energy", "Efficient Energy", "EGS Advanced Energy Solutions", "Electrasource", "Electric Advisors, Inc.", "Elite Energy Solutions", "Elixir Power Solutions", "EnerConnex", "Enerex", "Enerex Help Center", "Energy 4 U Inc.", "Energy Auction Exchange", "Energy Connection", "Energy Edge Consulting", "Energy Guru LLC", "Energy Harbor", "Energy Initiatives", "Energy Objective", "Energy Professionals", "Energy Source Consulting, LLC", "EnergyCX", "EnergyServ Solutions", "EnerPower", "Engie", "Even Load Energy", "Everlast Energy (No Plateau LLC)", "Evolution Energy Partners", "Evolution Promotions Inc.", "Evolving Energy", "EZ Choice Energy", "EZ Energy", "F and D Partners", "FPB Energy, LLC", "Freepoint", "Freepoint Solutions", "Frontline", "FS Energy LLC", "Global Energy Management", "Globele Energy", "Goldstar Energy", "Green Crown Energy", "Greenline Energy", "GSE Consulting, LP", "Guardian Electric and Gas", "Gulf Plains Energy", "Honest Gorilla", "Infinity Power Partners, LLC", "INSO Energy", "IntelliGen Resources", "J & H Energy", "Joule Assets", "Just Energy", "Kairos Energy Ventures", "KEYTEX Energy Solutions", "Kizmet Energy", "LakePoint Energy", "Latern Power", "Lexus Power", "Live Energy", "Lower Electric", "Lower Watt", "Lykins Energy Advisors", "M&R Energy Resources", "M3 Energy", "Marathon Energy", "MDM-Energy Solutions", "Mega Energy", "Meretz Energy LLC", "Metronome Energy", "MHSC Energy Management, LLC", "Mighty EM", "Momentum Energy Services", "MP2 Energy", "Nania Energy", "National Energy Brokers Inc.", "National Utility Refund LLC", "National1energy", "Nationwide New Energy", "NAUP", "Nelson Premier Energy", "New America Power", "New Era Power LLC", "New Rate Energy", "Nicor Gas", "Noble HIll Brokerage", "Novo Energy", "Ohio Industrial Energy", "Olivia Corp", "Onyx Power & Gas Consulting", "Op2mize Energy", "Orzel Energy", "P2P Energy Solutions, Inc.", "Palmer", "Pariveda", "Park Place Power", "Patent Energy", "Pathway Energy", "Peritus Energy and Water", "Power Brokers", "Power Connection", "Power Experts LLC", "Power Logix", "Powernmore", "Powerserv Tech", "Pratt Power Partners", "Precedo Capital", "Premier Energy", "Progressive Energy Consultants", "ProSource Power", "ProStar Energy Services", "Prudential Energy", "QFB Energy", "Quantum Gas and Power Services, LTD", "Quantum Spectrum Energy", "Rave Energy", "RealPage, Inc.", "Reflective Energy Solution", "Retail Power Services", "River Oaks Energy", "Sable Power and Gas", "Saigon Power (formerly Q2X)", "Savant Energy", "Schneider Electric", "Seven Utility Management Consultants", "Simplified Power", "Single Source Energy Solutions", "Sparkplug", "Spike Energy, Inc.", "Statistical Energy", "Stellar Energy Solutions", "Strategic Insights", "SU4Energy", "Summer Energy", "SunRise Energy, LLC", "Sustainable Westchester", "Switch Energy Office", "Switchenergyny", "Symbio Energy Partners", "Taurus Utility Consultants", "TES Energy Services", "Test", "Texzon Utilities", "The Energy Company", "The Energy Depot", "The Linc Group", "The Power Company", "Titan Energy New England", "Tobelmann Energy Brokers, Inc.", "Tomorrows Utilities", "TPL Energy", "Transparent Energy", "TransPower Energy Group", "Triple S Energy", "TXU", "U-Go Christ", "UCE Partners", "UControl Energy", "UES- United Energy Services", "Ultimate Energy Advisors, LLC", "Unified Energy Services, LLC", "United Commercial Energy Partners", "United Power Consultants", "USA Group Energy", "USEC LLC (US Energy Consultants)", "Utility Connect", "Utility Savings Group", "Utiliz", "Vantage ETC", "Varo Technologies", "Vault Energy Solutions", "Verity Power Group", "Voltstreet", "Watts Marketing Services", "World Kinect Energy Services", "World Kinect Energy Services [UK]", "Worthington Energy Consultants", "YG Energy Consulting", "Your Choice Energy LLC", "Zingo Energy"]
          customerField.allowedValues = _self.zdOrganizations;
        }

				//devOpsProjectData.customFields=devOpsProjectData.fieldsList.value.filter(d=>d.referenceName && d.referenceName.indexOf('Custom.')>=0);
				devOpsProjectData.customFields=devOpsProjectData.fieldsList.value.filter(d=>d.referenceName);
				_self.initFieldsDefaultVal(devOpsProjectData.fieldsList.value);
				_self.devOpsProjectData=devOpsProjectData;
				setTimeout(function(){_self.showFields=true;},500);
				if(cb) cb(devOpsProjectData);
				else{
					_self.fn().showLoader(false);
					_self.fn().updateJSTreeData('area_jstree',devOpsProjectData.nodesList.value.filter(d=>d.structureType=='area'));
					_self.fn().updateJSTreeData('iterations_jstree',devOpsProjectData.nodesList.value.filter(d=>d.structureType=='iteration'));
					_self.handleDefAreaIteration(devOpsProjectData);
					//setTimeout(function(){_self.applyDatePicker();},1000);
				}
			},function(err){
				_self.fn().showLoader(false);
				let erroList=[
					'We see your authentication token for the azure devops does not have required permissions.',
					'Can you please create azure devops token as per below article and update the app.',
					'https://support.devopsintegration.io/support/solutions/articles/82000451379-how-to-create-azure-devops-authentication-token-'
				]
				_self.userMsg={show:true,type:'danger',list:erroList};
			});
		},
		initFieldsDefaultVal(fieldsList){
			const _self=this;
			let defaultValFields=fieldsList.filter(d=>d.defaultValue!==undefined || d.type=='boolean');
			for(var i=0;i<defaultValFields.length;i++){
				if(defaultValFields[i].defaultValue){
					_self.createItemData.fields[defaultValFields[i].referenceName]=defaultValFields[i].defaultValue;
				}
				else if(defaultValFields[i].type=='boolean'){
					_self.createItemData.fields[defaultValFields[i].referenceName]=false;
				}
			}
		},
		async validateForm(){
			let isValid=await this.$validator.validateAll();

			if(!isValid){
				this.userMsg={show:true,type:'danger',list:[`Please scroll up and fill all required fields.`]}
			}
			return isValid;
		},
		//create init
		devOpsUsersFn:function(successCb,errorCb){
            var _self=this;
            var url = `dev-ops/users`;
            _self.fn().clearMessage();
			_self.postServerFn(url,null,successCb,errorCb);
        },
        devOpsProjectsFn:function(successCb,errorCb){
            var _self=this;
            var url = `dev-ops/projects`;
            _self.fn().clearMessage();
			_self.postServerFn(url,null,successCb,errorCb);
			// if(successCb){
			// 	return successCb({data:projectData});
			// }
        },
        devOpsProjectDataFn:function(projectId,successCb,errorCb){
            var _self=this;
            var url = `dev-ops/projects/${projectId}`;
            _self.fn().clearMessage();
			_self.postServerFn(url,null,successCb,errorCb);
			// if(successCb){
			// 	//let data=projectDetailsData.find(d=>d.ProjectId==projectId);
			// 	let data=projectDetailsData[0];//it will be same in all projects
			// 	return successCb({data:data});
			// }
        },
		createWorkItemFn(){
			let _self=this;
			_self.fn().clearMessage();
			if(_self.editor_reproSteps_Obj)
				_self.createItemData.fields['Microsoft.VSTS.TCM.ReproSteps']=_self.fn().getHtmlEditorContent(_self.editor_reproSteps_Obj);

			if(_self.editor_description_Obj)
				_self.createItemData.fields['System.Description']=_self.fn().getHtmlEditorContent(_self.editor_description_Obj);

			_self.createItemData.fields['System.Tags']=_self.createItemData.fields['System.TagsArr']?_self.createItemData.fields['System.TagsArr'].join(';'):'';
			let data=JSON.parse(JSON.stringify(_self.createItemData));
			data.auth=_self.zendeskInfo.credentials;
			data.user=_self.zendeskInfo.user;
			data.project = _self.devOpsProjects.find(d => d.id == data.projectId);

			if (data.fields['sparkplug-process.ClientName'] && Array.isArray(data.fields['sparkplug-process.ClientName'])) {
				data.fields['sparkplug-process.ClientName'] = data.fields['sparkplug-process.ClientName'].join(", ");
      }

      if (data.fields['Custom.Customer'] && Array.isArray(data.fields['Custom.Customer'])) {
				data.fields['Custom.Customer'] = data.fields['Custom.Customer'].join(", ");
      }

      if (!data.fields['System.AreaPath']) {
        _self.userMsg={show:true,type:'danger',list:[`Area Path is required. Please select the Area to create the work item..`]}
        return;
      }

			let newFields={};
			for(var key in data.fields){
				if(data.fields[key]){
					newFields[key]=data.fields[key];
				}
			}
			data.fields=newFields;
      delete data.fields['System.TagsArr'];

      let url = `dev-ops/workitems/create`;

      if(data.fields['Custom.Customer'] && data.fields['Custom.Customer'].length>0){
        data.fields['System.Title']=`ZD:${data.hdTicketId?data.hdTicketId:data.ticket.id} – ${data.fields['Custom.Customer']} – ${data.fields['System.Title']}`
      }else if(data.fields['sparkplug-process.ClientName'] && data.fields['sparkplug-process.ClientName'].length>0){
        data.fields['System.Title']=`ZD:${data.hdTicketId?data.hdTicketId:data.ticket.id} – ${data.fields['sparkplug-process.ClientName']} – ${data.fields['System.Title']}`
      }
      //data.fields['System.Title'] = `ZD:${data.hdTicketId ? data.hdTicketId : data.ticket.id} – ${data.fields['sparkplug-process.ClientName']} – ${data.fields['System.Title']}`

			_self.postServerFn(url,data,function(response){
				_self.fn().showLoader(false);
				let userMsg;
				if(response.data.Success){
					userMsg={show:true,type:'info',list:[response.data.Data?response.data.Data:`Work item created Successfully`]}
					_self.sendDataToParent(response.data);
				}else{
					_self.showTags=false;
					_self.createItemData.fields['System.TagsArr']=_self.createItemData.fields['System.Tags']?_self.createItemData.fields['System.Tags'].split(';'):[];
					setTimeout(function(){_self.showTags=true;},1000);
					userMsg={show:true,type:'danger',list:[response.data.Data?response.data.Data:`Work item creation failed.`]}
				}
				_self.userMsg=userMsg;
			},function(error){
				_self.fn().showLoader(false);
				_self.showTags=false;
				_self.createItemData.fields['System.TagsArr']=_self.createItemData.fields['System.Tags']?_self.createItemData.fields['System.Tags'].split(';'):[];
				setTimeout(function(){_self.showTags=true;},1000);
				_self.commonErrorMsgDisp(error);
			});
		},
		closeDialog(){
			modalClient.invoke('destroy');
		},
		sendDataToParent(data){
			parentClient.trigger('receive_data_from_modal', data)
      		modalClient.invoke('destroy');

		},
		postServerFn(url,data,successCb,errorCb){
			let _self=this;
			data=data?data:{};
			data.auth=_self.zendeskInfo.credentials;
			_self.post(url,data).then(response=>{
				if(successCb) successCb(response);
			}).catch(error=>{
				if(errorCb) errorCb(error);
			});
		}
	},
	components:{HtmlEditor,TagsInput,[Select.name]: Select,[Option.name]: Option}
}

